var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-skeleton-loading"},[_c('v-row',_vm._l((3),function(n){return _c('v-col',{key:n,staticClass:"text-center mt-3",attrs:{"cols":"12","sm":"12","lg":"4","md":"12"}},[_c('v-skeleton-loader',{attrs:{"type":"article"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }